<template>
  <div ref="printContent" style="text-align: center; width: 100%; height: 100%; max-width: 100%;">
    <template v-if="fileType == 'pdf'">
      <vue-office-pdf :src="getBasePath" @error="errorHandler" @rendered="rendered" />
    </template>
    <!-- <div style="overflow: auto"  v-else-if="fileType == 'image'"> -->
    <img
      :alt="fileOption.fileName"
      :src="getBasePath"
      mode="aspectFit"
      style="max-width: 100%"
      v-else-if="fileType == 'image'"
    />
    <!-- </div> -->
    <template v-else-if="fileType == 'video'">
      <video :autoplay="false" :src="getBasePath" controls ref="video" width="100%"></video>
    </template>
    <template v-else-if="fileType == 'audio'">
      <audio controls ref="audio" width="100%">
        <source :src="getBasePath" />
      </audio>
    </template>
    <template v-else-if="fileType == 'docx'">
      <vue-office-docx :src="getBasePath" @error="errorHandler" @rendered="rendered" />
    </template>
    <template v-else-if="fileType == 'doc'">
      <!-- <div class="docWrap" id="docView" ref="docFile"></div> -->
      <VueDocPreview :class="'docContainer'" :type="'office'" :value="getBasePath" />
    </template>
    <template v-else-if="fileType == 'xlsx'">
      <vue-office-excel :src="getBasePath" @error="errorHandler" @rendered="rendered" />
    </template>
    <template v-else-if="fileType == 'xls'">
      <VueDocPreview :class="'docContainer'" :type="'office'" :value="getBasePath" />
      <!-- <div class="xlsContainer" id="excelView" ref="xlsFile" v-html="tableau"></div> -->
      <!-- <iframe :src="`https://view.officeapps.live.com/op/view.aspx?src=${getFullPath}`" /> -->
    </template>
    <template v-else>当前文件暂不支持预览，请下载查看</template>
  </div>
</template>
<script>
//引入VueOfficeDocx组件
import VueOfficeDocx from '@vue-office/docx'
//引入相关样式
import '@vue-office/docx/lib/index.css'
//引入VueOfficeExcel组件
import VueOfficeExcel from '@vue-office/excel'
//引入相关样式
import '@vue-office/excel/lib/index.css'
//引入VueOfficePdf组件
import VueOfficePdf from '@vue-office/pdf'
// import axios from 'axios'
// 预览excel文件
// const XLSX = require("xlsx")

// https://vdp.cainsyake.com/
import VueDocPreview from 'vue-doc-preview'

export default {
  name: 'filePreview',
  props: {
    fileOption: {
      required: true,
      type: Object,
      default: {}
    },
  },
  components: {
    VueOfficeDocx, VueOfficeExcel, VueOfficePdf, VueDocPreview
  },
  data () {
    return {
      showSpan: false,
      tableau: ''
    }
  },
  computed: {
    getBasePath: function () {
      console.log('this.fileOption', this.fileOption)
      if (this.fileOption.public && this.fileOption.fileUrl) {
        return this.fileOption.fileUrl
      } else {
        return process.env.VUE_APP_API_ROOT + this.$apis.fileServerApi.getFile + "?id=" + this.fileOption.fileId
      }
    },
    fileType: function () {
      let that = this
      let type = this.$common.getFileType(this.fileOption.fileType || '')
      console.log('type', type)
      switch (type) {
        case 'doc':
          // let config = { responseType: 'blob' }
          // let docx = require("docx-preview")
          // that.$axios.get(this.$apis.fileServerApi.getFile + "?id=" + this.fileOption.fileId, null, config).then(res => {
          //   that.$nextTick(() => {
          //     docx.renderAsync(res, that.$refs.docFile) // 渲染到页面预览
          //   })

          // }).catch(function (err) {
          //   console.log(err)
          //   that.$Message.error('获取失败！')
          // })
          break
        case 'xls':
        // axios.get(this.getBasePath, {
        //   responseType: "arraybuffer", // 设置响应体类型为arraybuffer
        // }).then(({ data }) => {
        //   let workbook = XLSX.read(new Uint8Array(data), { type: "array" }) // 解析数据
        //   console.log('workbook.SheetNames', workbook.SheetNames)
        //   let worksheet = workbook.Sheets[workbook.SheetNames[0]] // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
        //   that.tableau = XLSX.utils.sheet_to_html(worksheet) // 渲染
        //   that.$nextTick(() => {
        //     that.setStyle4ExcelHtml()
        //   })
        // })
      }
      return type
    }
  },
  methods: {
    setStyle4ExcelHtml () {
      const excelViewDOM = document.getElementById("excelView")
      if (excelViewDOM) {
        const excelViewTDNodes = excelViewDOM.getElementsByTagName("td") // 获取的是HTMLConnection
        if (excelViewTDNodes) {
          const excelViewTDArr = Array.prototype.slice.call(excelViewTDNodes)
          for (const i in excelViewTDArr) {
            const id = excelViewTDArr[i].id // 默认生成的id格式为sjs-A1、sjs-A2......
            if (id) {
              const idNum = id.replace(/[^0-9]/gi, "") // 提取id中的数字，即行号
              if (idNum && (idNum === "1" || idNum === 1)) {
                // 第一行标题行
                excelViewTDArr[i].classList.add("class4Title")
              }
              if (idNum && (idNum === "2" || idNum === 2)) {
                // 第二行表头行
                excelViewTDArr[i].classList.add("class4TableTh")
              }
            }
          }
        }
      }
    },
    rendered: function () {
      console.log('rendered...')
    },
    errorHandler: function (err) {
      console.log('errorHandler...', err)
    },
    download: function () {
      let that = this
      this.showSpan = true
      let config = { responseType: 'blob' }
      that.$axios.post(this.$apis.fileServerApi.getFile + "?id=" + this.fileOption.fileId, null, config).then(res => {
        let url = window.URL.createObjectURL(new Blob([res.data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.download = decodeURI(res.headers['content-disposition'].split('=')[1])
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
      }).catch(function (err) {
        console.log("exportAll error", err)
        that.$Message.error('模载失败！')
      }).finally(() => {
        that.showSpan = false
      })
    },
  },
}
</script>
<style lang="less">
.xlsContainer table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  td {
    border: 1px solid #e8eaec;
    word-break: break-all;
  }
}

.docContainer {
  .WACRibbonPanel {
    display: none;
  }
}
</style>